function NotFound() {
    return(
        <div className={"container font-primary"}>
            페이지를 찾을 수 없습니다.
        </div>
    )
}

export default NotFound;